/* eslint-disable */
import axios from 'axios'
import { memoryAdapter } from 'axios-extensions'
import i18next from 'i18next'

import { reactive } from "vue";
import { io } from "socket.io-client";

export const state = reactive({
  connected: false,
  fooEvents: [],
  barEvents: []
});

window.appInstanceCache = {};
window.cache_date = null;
const CACHE_TIME_LIMIT = 60000 * 720; // 1 minute * n
const MAX_REQUESTS_COUNT = 5
const INTERVAL_MS = 10
let PENDING_REQUESTS = 0

window.numberOfAjaxCallPending = 0;
let VUE_APP_API_BASE_URL = 'https://gateway.taptasty.com/';
if (process.env.VUE_APP_API_BASE_URL) {
  VUE_APP_API_BASE_URL = process.env.VUE_APP_API_BASE_URL
}
window.is_local = 0
if (process.env.VUE_APP_IS_LOCAL) {
  window.is_local = parseInt(process.env.VUE_APP_IS_LOCAL)
}
window.API_HOST = VUE_APP_API_BASE_URL
// console.log(VUE_APP_API_BASE_URL);
// console.log(process.env.NODE_ENV);

let appInstance = axios.create({
  baseURL: window.API_HOST,
  withCredentials: false,
  timeout: 1000 * 60 * 10,
  adapter: memoryAdapter
})
appInstance.interceptors.request.use(function (config) {
  return new Promise((resolve, reject) => {
    let interval = setInterval(() => {
      if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
        PENDING_REQUESTS++
        clearInterval(interval)
        resolve(config)
      } 
    }, INTERVAL_MS)
  })
})
/**
 * Axios Response Interceptor
 */
appInstance.interceptors.response.use(function (response) {
  PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
  return Promise.resolve(response)
}, function (error) {
  PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
  return Promise.reject(error)
})

const localAppInstance = axios.create({
  baseURL: 'http://localhost:6999/',
  withCredentials: false,
  timeout: 1000 * 60 * 10 
})
const localFiscalNetInstance = axios.create({
  // baseURL: 'http://192.168.100.44:65400/',
  baseURL: 'http://localhost:65400/',
  withCredentials: false,
  timeout: 1000 * 60 * 10 
})
import getBrowserFingerprint from 'get-browser-fingerprint';
export const utilsMixin = {
  data() {
    return {
      socket: null,
      databaseName: '',
      intervalForDatabaseCache: null,
      refresh_products_date: null,
      login_date: null,
      qr_link: null,
      cardQrPaymentEnabled: false,
      kiosk_is_using_top_category: null,
      kiosk_is_using_fiscal_receipt_for_cash: null,
      use_smso: null,
      loyalty_in_use: null,
      kiosk_pass: null,
      scaner_position: null,
      use_pager: false,
      isUsingCashMachine: false,
      colors: [],
      timeoutRefrashIfError: null,
      packing_method: null,
      DBprinter: false,
      DBpos: false,
      DBfiscal: false,
      DBfiscalNet: false,
      DBfiscalNetWithPos: false,
      token: false,
      shopping_cart_id: false,
      json: {},
      version: 1,
      position: null,
      error: true,
      errorType: 1,
      fingerprint: false,
      companyLogo: '../logott.png',
    };
  },
  created () {
    // *** also in App.vue
    this.json = new URL(location.href).searchParams.get('table')
    this.json = JSON.parse(atob(atob(this.json).substring(3)))
    // ***
    if (this.json) {
      if ((Math.floor(Date.now() / 1000) - this.json.timestamp) < 300) {  // 300sec = 5 min
        this.error = false
        this.errorType = 0
      }
    }
    if (this.json.type == 'Kiosk' || window.is_local) {
      this.error = false
      this.errorType = 0
    }
    // this.openApp();
    this.colors = {
      addBtnColor: '#ffca40',
      addBtnColorInv: '#000',
      iconsColor1: '#942007',
      iconsColor2: '#fff',
      secundarColor: '#B33012',
      principalColor: '#4D966D'
    }
    // if (localStorage['tapTable_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id]) {
    //   window.appInstanceCache = JSON.parse(localStorage['tapTable_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id])
    // }

    let time = 30000 // 0.5 min
    if (this.json.type == 'Kiosk') {
      time = 120000 // 2 min
    }
    
    this.databaseName = 'table_' + this.json.location_token + '_comp_' + this.json.company_id
    
    let versionDB = 2 // onupgradeneeded event if change the version
    this.openDatabaseAndReadOrCreate(this.databaseName, versionDB, 'menuForKiosk', 0);
    clearInterval(this.intervalForDatabaseCache)
    this.intervalForDatabaseCache = setInterval(()=>{
      this.openDatabaseAndReadOrCreate(this.databaseName, versionDB, 'menuForKiosk', 1);
    }, time)


    if (localStorage['tapTable_cache_date_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id]) {
      window.cache_date = new Date(localStorage['tapTable_cache_date_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id])
    }
  },
  methods: {
    openApp () {
      let packageName = "rosecasApp"
      let params = new URLSearchParams({
        foo: 'bar',
        baz: 'boom',
        cow: 'milk',
        php: 'hypertext processor'
      })
      // params = 'table?'. params.toString();
      window.location = 'intent://'+params+'#Intent;package=com.inmobito.'+packageName+';scheme='+packageName+';end;'
    },
    doThelogin (callback) {
      this.apiRequest('login-table', 'POST', {
            'position': this.position,
            'company_id': this.json.company_id,
            'table_id': this.json.id,
          }, (resp) => {
        if (resp.data && resp.data.status == true) {
          this.error = false
          this.errorType = 0
          clearTimeout(this.timeoutRefrashIfError)
          this.refresh_products_date = resp.data.data.refresh_products_date
          this.companyLogo = resp.data.data.logo
          this.token = resp.data.data.token
          this.shopping_cart_id = resp.data.data.shopping_cart_id
          this.DBfiscal = JSON.parse(resp.data.data.fiscal)
          this.DBfiscalNet = resp.data.data.use_fiscal_net
          this.DBfiscalNetWithPos = resp.data.data.use_fiscal_net_with_pos
          this.DBprinter = JSON.parse(resp.data.data.printer)
          this.DBpos = JSON.parse(resp.data.data.pos)
          this.packing_method = resp.data.data.packing_method
          this.isUsingCashMachine = resp.data.data.use_cash_machine
          this.cardQrPaymentEnabled = resp.data.data.use_card_qr_payment

          if (this.isUsingCashMachine && !this.socket) {
            this.socket = io("http://localhost:6997/", { autoConnect: false });

            this.socket.on("connect", () => {
              state.connected = true;
            });

            this.socket.on("disconnect", () => {
              state.connected = false;
            });

            this.socket.on("connection", (...args) => {
              state.fooEvents.push(args);
            });
          }

          // this.colors = resp.data.data.colors
          if (resp.data.data.colors) {
            if (resp.data.data.colors.principalColor) {
              this.colors.principalColor = resp.data.data.colors.principalColor;
            }
            if (resp.data.data.colors.secundarColor) {
              this.colors.secundarColor = resp.data.data.colors.secundarColor;
            }
            if (resp.data.data.colors.addBtnColor) {
              this.colors.addBtnColor = resp.data.data.colors.addBtnColor;
            }
            if (resp.data.data.colors.addBtnColorInv) {
              this.colors.addBtnColorInv = resp.data.data.colors.addBtnColorInv;
            }
            if (resp.data.data.colors.iconsColor1) {
              this.colors.iconsColor1 = resp.data.data.colors.iconsColor1;
            }
            if (resp.data.data.colors.iconsColor2) {
              this.colors.iconsColor2 = resp.data.data.colors.iconsColor2;
            }
          }
          
          this.qr_link = resp.data.data.qr_link
          this.use_pager = !!resp.data.data.use_pager
          this.scaner_position = resp.data.data.scaner_position
          this.kiosk_pass = resp.data.data.kiosk_pass
          this.kiosk_is_using_top_category = resp.data.data.kiosk_is_using_top_category
          this.kiosk_is_using_fiscal_receipt_for_cash = resp.data.data.kiosk_is_using_fiscal_receipt_for_cash
          this.use_smso = resp.data.data.use_smso
          this.loyalty_in_use = resp.data.data.loyalty_in_use
          if (!this.kiosk_pass) {
            this.kiosk_pass = this.json.id
          }
          callback(resp.data.data.ask_to_empty_the_order)
        } else {
          this.error = true
          if (resp.data.errors && resp.data.errors.cid === 'cid') {
            this.errorType = 2
          }
          if (resp.data.errors && resp.data.errors.tid === 'tid') {
            this.errorType = 3
          }
          if (resp.data.errors && resp.data.errors.uid === 'uid') {
            this.errorType = 4
          }
          if (resp.data.errors && resp.data.errors.email === 'email') {
            this.errorType = 5
          }
          if (resp.data.errors && resp.data.errors.ld === 'ld') {
            this.errorType = 6
          }
          if (resp.data.errors && resp.data.errors.distance === 'distance') {
            this.errorType = 7
          }
          if (resp.data.errors && resp.data.errors.close === 'close') {
            this.errorType = 8
          }
        }
      })
    },
    getCurrentLocation (callback) {
      if (navigator.geolocation && this.json.type != 'Kiosk') {
        navigator.geolocation.getCurrentPosition((position) => {
          this.position = {
            'accuracy': position.coords.accuracy,
            'altitude': position.coords.altitude,
            'altitudeAccuracy': position.coords.altitudeAccuracy,
            'heading': position.coords.heading,
            'latitude': position.coords.latitude,
            'longitude': position.coords.longitude,
            'speed': position.coords.speed
          }
          this.doThelogin(callback)
        }, (e) => {
          console.log(e)
          console.log('ERROR Location')
          this.position = null
          this.doThelogin(callback)
        });
      } else {
        this.position = null
        this.doThelogin(callback)
      }
      this.timeoutRefrashIfError = setTimeout(() => {
        this.getCurrentLocation(callback)
      }, 10 * 60000);
    },
    changeLanguage(lng = null) {
      if (lng) {
        i18next.changeLanguage(lng)
        return lng
      } else {
        if (i18next.language == 'en') {
          i18next.changeLanguage('ro')
          // return 'en'
        } else {
          i18next.changeLanguage('en')
          // return 'ro'
        }
        return i18next.language
      }
    },
    clickOnRef (ref) {
      this.$refs[ref][0].click()
    },
    localRequestFiscalNet (url, method, data, callback) {
      data = data || {};

      localFiscalNetInstance.interceptors.request.use(function (config) {
          window.numberOfAjaxCallPending++;
          return config;
      }, function (error) {
          return Promise.reject(error);
      });

      localFiscalNetInstance.interceptors.response.use(function (response) {
        window.numberOfAjaxCallPending--;

        return response
      }, function (error) {
        window.numberOfAjaxCallPending--;

        return Promise.reject(error)
      })

      const headers = {
        'Content-Type': 'text/plain',
      };

      switch (method) {
        case 'GET':
          localFiscalNetInstance.get(url, {params: data}).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
          })
          break
        case 'POST':
          localFiscalNetInstance.post(url, '[\n'+data+'\n]', { headers } ).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
            callback(0)
          })
          break
        case 'PUT':
          localFiscalNetInstance.put(url, data).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
          })
          break
        case 'DELETE':
          localFiscalNetInstance.delete(url).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
          })
          break
      }
    },
    localRequest (url, method, data, callback) {
      data = data || {};

      localAppInstance.interceptors.request.use(function (config) {
          window.numberOfAjaxCallPending++;
          return config;
      }, function (error) {
          return Promise.reject(error);
      });

      localAppInstance.interceptors.response.use(function (response) {
        window.numberOfAjaxCallPending--;

        return response
      }, function (error) {
        window.numberOfAjaxCallPending--;

        return Promise.reject(error)
      })

      switch (method) {
        case 'GET':
          localAppInstance.get(url, {params: data}).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
          })
          break
        case 'POST':
          localAppInstance.post(url, data).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
          })
          break
        case 'PUT':
          localAppInstance.put(url, data).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
          })
          break
        case 'DELETE':
          localAppInstance.delete(url).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
          })
          break
      }
    },
    apiRequest (url, method, data, callback) {
      if (!this.fingerprint) {
        this.fingerprint = getBrowserFingerprint();
      }
      data = data || {};
      data['device_id'] = window.uuid;
      data['version'] = this.version;
      data['fingerprint'] = this.fingerprint;
      data['device_info'] = window.device || {};

      // if (this.json.company_id == 91) {
      //   appInstance = axios.create({
      //     baseURL: 'https://ml01.taptasty.com:9999/',
      //     withCredentials: false,
      //     timeout: 1000 * 60 * 10
      //   })
      // }

      let token = localStorage['tapTastyOrder-' + this.fingerprint]

      const cacheKey = JSON.stringify({ url, method, data });
      if (window.appInstanceCache[cacheKey] && (Date.now() - window.appInstanceCache[cacheKey].timestamp) < CACHE_TIME_LIMIT) {
        // If response is cached and not expired, return it
        window.appInstanceCache[cacheKey].response.requestFromCache = true;
        callback(JSON.parse(JSON.stringify(window.appInstanceCache[cacheKey].response)));
        return;
      }



      appInstance.interceptors.request.use(function (config) {
          window.numberOfAjaxCallPending++;

          if (window.numberOfAjaxCallPending == 1) {
            setTimeout(function() {
              if (window.numberOfAjaxCallPending >= 1) {
                // self.$f7.preloader.show();
              }
            }, 1 * 1000);
          }

          return config;
      }, function (error) {
          return Promise.reject(error);
      });

      appInstance.interceptors.response.use( (response) => {
        if (response.data && response.data.data && response.data.data.token) {
          localStorage['tapTastyOrder-' + this.fingerprint] = response.data.data.token
        }

        window.numberOfAjaxCallPending--;

        if (window.numberOfAjaxCallPending <= 0) {
          // self.$f7.preloader.hide();
        }

        return response
      }, function (error) {
        window.numberOfAjaxCallPending--;

        if (window.numberOfAjaxCallPending == 0) {
          // self.$f7.preloader.hide();
        }

        return Promise.reject(error)
      })

      //appInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

      if (token) {
        appInstance.defaults.headers.common['Authorization'] = 'Bearer ' + token
      }

      switch (method) {
        case 'GET':
          appInstance.get(url, {params: data}).then(res => {
            if (data.with_cache) {
              window.appInstanceCache[cacheKey] = {
                response: JSON.parse(JSON.stringify(res)),
                timestamp: Date.now()
              }
              // localStorage['tapTable_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id] = JSON.stringify(window.appInstanceCache)
            }
            callback(res)
          }).catch(err => {
            console.log(err)
          })
          break
        case 'POST':
          appInstance.post(url, data).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
          })
          break
        case 'PUT':
          appInstance.put(url, data).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
          })
          break
        case 'DELETE':
          appInstance.delete(url).then(res => {
            callback(res)
          }).catch(err => {
            console.log(err)
          })
          break
      }
    },
    openDatabaseAndReadOrCreate(dbName, version, storeName, $insert1Read0) {
      let self = this
      // Open a connection to the database
      let request = indexedDB.open(dbName, version);

      // Handle database setup or upgrade
      request.onupgradeneeded = (event) => {
        let db = event.target.result;
        // Create an object store if it doesn't exist
        console.log(db.objectStoreNames);
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: 'key' });
        }
      };

      // Handle success opening database
      request.onsuccess = (event) => {
        let db = event.target.result;
        if ($insert1Read0) {
          self.insertDefaultData(db, storeName);
        } else {
          // Start a transaction to read data
          let transaction = db.transaction([storeName], 'readonly');
          let objectStore = transaction.objectStore(storeName);

          // Get all records from the object store
          let getAllRequest = objectStore.getAll();

          getAllRequest.onsuccess = (event) => {
            let records = event.target.result;
            let reconstructedObject = {};
            records.forEach(record => {
              reconstructedObject[record.key] = record.value;
            });
            window.appInstanceCache = reconstructedObject;
            console.log('getFromDb')
          };

          getAllRequest.onerror = (event) => {
            // console.error('Error reading records:', event.target.error);
          };

          transaction.oncomplete = () => {
            db.close();
          };
        }
      };

      request.onerror = (event) => {
        console.error('Database error:', event.target.error);
      };
    },
    insertDefaultData(db, storeName) {
      let transaction = db.transaction([storeName], 'readwrite');
      let objectStore = transaction.objectStore(storeName);

      let defaultData = Object.entries(window.appInstanceCache);

      defaultData.forEach(([key, value]) => {

        let item = {
          key: key,
          value: value
        };

        let putRequest = objectStore.put(item);

        putRequest.onsuccess = (event) => {
          // console.log('Default data inserted or updated:', item);
        };

        putRequest.onerror = (event) => {
          // console.error('Error inserting or updating default data:', event.target.error);
        };
      });

      transaction.oncomplete = () => {
        db.close();
        console.log('savedInDb')
      };
    },
    generateLargeData(size) {
      let data = '';
      for (let i = 0; i < size; i++) {
        data += 'a'; // or any other character
      }
      return data;
    },
    prefetchImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
          resolve(url);
        };
        img.onerror = reject;
      });
    },
    async fetchAndSetImage(url) {
      try {
        const loadedImage = await this.prefetchImage(url)
        // this.prefetchedImage = loadedImage;
        // this.imageLoaded = true;
      } catch (error) {
        console.error('Error prefetching image:', error)
      }
    },
    async prefetchImages(urls) {
      try {
        const loadedImages = await Promise.all(urls.map(url => this.prefetchImage(url)))
        // this.prefetchedImage = loadedImages[0];
        // this.imageLoaded = true;
      } catch (error) {
        console.error('Error prefetching images:', error)
      }
    }
  }
}